import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { Result, mappingResultError } from '@digibricks/domains';
import { FILE_STORAGE_V2_REPOSITORY } from '../../core';
import { FILE_STORAGE_V2_API } from '../data-sources';
import { FileV2Mapper } from './file-v2.mapper';
export var FileStorageV2Repository = /*#__PURE__*/function () {
  function FileStorageV2Repository(fileStorageV2Api, fileV2Mapper) {
    _classCallCheck(this, FileStorageV2Repository);

    this.fileStorageV2Api = fileStorageV2Api;
    this.fileV2Mapper = fileV2Mapper;
  }

  _createClass(FileStorageV2Repository, [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.fileStorageV2Api.create(input);

              case 2:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", mappingResultError(responseOrError));

              case 5:
                return _context.abrupt("return", Result.ok(responseOrError.getValue()));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function create(_x) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "getManyV2",
    value: function () {
      var _getManyV = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
        var responseOrError, response, files, _iterator, _step, item, domainOrError;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.fileStorageV2Api.getManyV2(input);

              case 2:
                responseOrError = _context2.sent;

                if (!responseOrError.isFailure) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", mappingResultError(responseOrError));

              case 5:
                response = responseOrError.getValue();
                files = [];
                _iterator = _createForOfIteratorHelper(response.items);
                _context2.prev = 8;

                _iterator.s();

              case 10:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 18;
                  break;
                }

                item = _step.value;
                domainOrError = this.fileV2Mapper.toDomain(item);

                if (!domainOrError.isFailure) {
                  _context2.next = 15;
                  break;
                }

                return _context2.abrupt("return", Result.fail(domainOrError.error));

              case 15:
                files.push(domainOrError.getValue());

              case 16:
                _context2.next = 10;
                break;

              case 18:
                _context2.next = 23;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2["catch"](8);

                _iterator.e(_context2.t0);

              case 23:
                _context2.prev = 23;

                _iterator.f();

                return _context2.finish(23);

              case 26:
                return _context2.abrupt("return", Result.ok({
                  items: files,
                  nextToken: response.nextToken
                }));

              case 27:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[8, 20, 23, 26]]);
      }));

      function getManyV2(_x2) {
        return _getManyV.apply(this, arguments);
      }

      return getManyV2;
    }()
  }, {
    key: "deleteV2",
    value: function () {
      var _deleteV = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.fileStorageV2Api.deleteV2(id);

              case 2:
                responseOrError = _context3.sent;

                if (!responseOrError.isFailure) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", mappingResultError(responseOrError));

              case 5:
                return _context3.abrupt("return", Result.ok());

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function deleteV2(_x3) {
        return _deleteV.apply(this, arguments);
      }

      return deleteV2;
    }()
  }]);

  return FileStorageV2Repository;
}();
export var fileStorageV2RepositoryProvider = {
  provide: FILE_STORAGE_V2_REPOSITORY,
  useFactory: function useFactory(fileStorageV2Api, fileV2Mapper) {
    return new FileStorageV2Repository(fileStorageV2Api, fileV2Mapper);
  },
  inject: [FILE_STORAGE_V2_API, FileV2Mapper]
};